import type { StateCreator } from 'zustand';

import { i18next } from '../i18n';

import type { Slices, UiSlice } from './types';

export const createUiSlice: StateCreator<Slices, [], [], UiSlice> = (set) => ({
  ui: {
    // Seeded from i18next's detector, which has already read localStorage and
    // the browser language and folded regional variants (frontend.md §5.2).
    locale: i18next.resolvedLanguage === 'en' ? 'en' : 'es',
    animationLevel: 'full',
    animationLevelExplicit: false,
    sound: true,
    chatOpen: false,
    senasCollapsed: false,

    setLocale: (locale) => {
      void i18next.changeLanguage(locale);
      set((s) => ({ ui: { ...s.ui, locale } }));
    },

    // Choosing a level is also a statement that the OS preference should stop
    // deciding for them — in either direction. Someone who runs the whole system
    // with reduced motion and still wants the cards to fly gets to say so.
    setAnimationLevel: (animationLevel) => {
      set((s) => ({ ui: { ...s.ui, animationLevel, animationLevelExplicit: true } }));
    },

    setSound: (sound) => {
      set((s) => ({ ui: { ...s.ui, sound } }));
    },

    setChatOpen: (chatOpen) => {
      set((s) => ({ ui: { ...s.ui, chatOpen } }));
    },

    setSenasCollapsed: (senasCollapsed) => {
      set((s) => ({ ui: { ...s.ui, senasCollapsed } }));
    },
  },
});
